"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getHeatmapUtilityClass = getHeatmapUtilityClass;
exports.heatmapClasses = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _generateUtilityClass = _interopRequireDefault(require("@mui/utils/generateUtilityClass"));
var _generateUtilityClasses = _interopRequireDefault(require("@mui/utils/generateUtilityClasses"));
function getHeatmapUtilityClass(slot) {
  // Those should be common to all charts
  if (['highlighted', 'faded'].includes(slot)) {
    return (0, _generateUtilityClass.default)('Charts', slot);
  }
  return (0, _generateUtilityClass.default)('MuiHeatmap', slot);
}
const heatmapClasses = exports.heatmapClasses = (0, _extends2.default)({}, (0, _generateUtilityClasses.default)('MuiHeatmap', ['cell', 'series']), {
  highlighted: 'Charts-highlighted',
  faded: 'Charts-faded'
});